<!-- ══════ List Payer ══════ -->
<div style="padding: 24px 16px; max-width: 1200px; margin: 0 auto;">
  <div style="background: white; border-radius: 20px; box-shadow: 0 4px 20px rgba(0,0,0,0.08); border: 1px solid #e5e7eb; overflow: hidden;">

    <!-- ── Header gradiente ── -->
    <div style="background: linear-gradient(135deg, #1e5a3f 0%, #059669 100%); padding: 20px 24px;">
      <div style="display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 12px;">
        <div style="display: flex; align-items: center; gap: 10px;">
          <mat-icon style="font-size: 26px; width: 26px; height: 26px; color: #a7f3d0;">groups</mat-icon>
          <h1 style="margin: 0; font-size: 1.3rem; font-weight: 800; color: white; letter-spacing: 0.3px;">
            Pagadores
          </h1>
        </div>
        <button *ngIf="!isAdminView" type="button" routerLink="/wallet/client/payer-invitations"
          style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 20px; background: rgba(255,255,255,0.15); color: white; border: 1px solid rgba(255,255,255,0.3); border-radius: 10px; font-weight: 600; font-size: 0.82rem; cursor: pointer; transition: all 0.2s ease; backdrop-filter: blur(4px);"
          onmouseover="this.style.background='rgba(255,255,255,0.25)'" onmouseout="this.style.background='rgba(255,255,255,0.15)'">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">person_add</mat-icon>
          Registrar pagador
        </button>
      </div>
    </div>

    <!-- ── Body ── -->
    <div style="padding: 0;" *ngIf="dataSource; else noPayers">

      <!-- ── Filtro / búsqueda ── -->
      <div style="padding: 16px 24px; border-bottom: 1px solid #f3f4f6;">
        <div style="position: relative; max-width: 380px;">
          <mat-icon style="position:absolute; left:10px; top:50%; transform:translateY(-50%); font-size:18px; width:18px; height:18px; color:#9ca3af;">search</mat-icon>
          <input type="text" placeholder="Buscar por nombre, documento o razón social…"
            (input)="aplicarFiltro($any($event.target).value)"
            style="width:100%; box-sizing:border-box; padding:9px 12px 9px 34px; border:1px solid #e5e7eb; border-radius:10px; font-size:0.85rem; outline:none;" />
        </div>
        <p *ngIf="!isAdminView" style="margin: 10px 0 0; font-size: 0.75rem; color: #6b7280; line-height: 1.4;">
          Solo se acreditan los depósitos de pagadores <strong style="color:#16a34a;">Habilitados</strong>.
          Los que están <strong style="color:#b45309;">En revisión</strong> los está validando nuestro equipo.
          Los <strong style="color:#4b5563;">Bloqueados</strong> ya no reciben abonos.
        </p>
      </div>

      <!-- ══ Desktop: Tabla (hidden en mobile) ══ -->
      <div class="hidden lg:block" style="overflow-x: auto;">
        <table mat-table [dataSource]="dataSource" class="payer-table" style="width: 100%;">

          <ng-container *ngFor="let column of columns" [matColumnDef]="column.columnDef">
            <th mat-header-cell *matHeaderCellDef>{{column.header}}</th>
            <td mat-cell *matCellDef="let row">{{column.cell(row)}}</td>
          </ng-container>

          <ng-container matColumnDef="cliente">
            <th mat-header-cell *matHeaderCellDef>Cliente</th>
            <td mat-cell *matCellDef="let row">
              <div style="display:flex; flex-direction:column; line-height:1.3;">
                <span style="font-weight:600; color:#111827;">{{ clienteNombre(row) }}</span>
                <span style="font-size:0.72rem; color:#6b7280;">
                  ID {{ row.usuario?.usuarioId ?? '—' }} · {{ row.usuario?.email ?? '—' }}
                </span>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="estado_compliance">
            <th mat-header-cell *matHeaderCellDef>{{ isAdminView ? 'Estado compliance' : 'Estado' }}</th>
            <td mat-cell *matCellDef="let row">
              <span [style.background]="estadoBadge(row).bg" [style.color]="estadoBadge(row).color"
                style="display:inline-block; padding:3px 10px; border-radius:20px; font-size:0.72rem; font-weight:700; white-space:nowrap;">
                {{ estadoBadge(row).label }}
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="fecha_registro">
            <th mat-header-cell *matHeaderCellDef>Fecha registro</th>
            <td mat-cell *matCellDef="let element">
              {{element.created_at | date: 'medium' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="acciones">
            <th mat-header-cell *matHeaderCellDef>Acciones</th>
            <td mat-cell *matCellDef="let element">
              <div style="display: flex; align-items: center; gap: 4px;">
                <button *ngIf="!isAdminView" title="Editar"
                  [routerLink]="['/wallet/client/edit-payer', element.pagadorId]"
                  style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #bfdbfe; border-radius: 6px; background: #eff6ff; cursor: pointer;">
                  <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #2563eb;">edit</mat-icon>
                </button>
                <button *ngIf="puedeEliminar(element)" title="Eliminar"
                  (click)="eliminar(element.pagadorId)"
                  style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #fecaca; border-radius: 6px; background: #fef2f2; cursor: pointer;">
                  <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #dc2626;">delete</mat-icon>
                </button>
                <button *ngIf="isAdminView" title="Ver pagador"
                  (click)="openPagadorData(element)"
                  style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #d1d5db; border-radius: 6px; background: white; cursor: pointer;">
                  <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #1C593D;">visibility</mat-icon>
                </button>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>

      <!-- ── Paginador (desktop) ── -->
      <mat-paginator class="hidden lg:block"
        [pageSize]="10" [pageSizeOptions]="[10, 25, 50, 100]"
        showFirstLastButtons>
      </mat-paginator>

      <!-- ══ Mobile: Cards (visible solo en mobile) ══ -->
      <!-- Usa dataSource.filteredData (no listaCuentas): en la vista admin los
           pagadores entran por setPagadores → solo llena dataSource. Además así
           las cards respetan el buscador. -->
      <div class="lg:hidden" style="padding: 16px; display: flex; flex-direction: column; gap: 10px;">
        <div *ngFor="let element of dataSource.filteredData"
          style="background: white; border: 1px solid #e5e7eb; border-radius: 14px; padding: 16px; box-shadow: 0 1px 4px rgba(0,0,0,0.04);">

          <!-- Card header -->
          <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px;">
            <div style="display: flex; align-items: center; gap: 8px;">
              <div style="width: 36px; height: 36px; border-radius: 10px; display: flex; align-items: center; justify-content: center;"
                [style.background]="element.tipoUsuarioId === 1 ? '#eff6ff' : '#f0fdf4'">
                <mat-icon style="font-size: 18px; width: 18px; height: 18px;"
                  [style.color]="element.tipoUsuarioId === 1 ? '#2563eb' : '#1C593D'">
                  {{ element.tipoUsuarioId === 1 ? 'business' : 'person' }}
                </mat-icon>
              </div>
              <div>
                <div style="font-size: 0.88rem; font-weight: 700; color: #111827;">
                  {{ nombre(element) }}
                </div>
                <div style="font-size: 0.75rem; color: #6b7280;">
                  {{ element.tipoUsuarioId === 1 ? 'Empresa' : 'Persona' }}
                </div>
              </div>
            </div>
            <span [style.background]="estadoBadge(element).bg" [style.color]="estadoBadge(element).color"
              style="font-size: 0.72rem; font-weight: 700; padding: 3px 10px; border-radius: 20px; white-space: nowrap; flex-shrink: 0;">
              {{ estadoBadge(element).label }}
            </span>
          </div>

          <!-- Card body -->
          <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 8px; font-size: 0.8rem;">
            <div>
              <span style="color: #9ca3af; font-size: 0.72rem;">Documento</span>
              <div style="color: #374151; font-weight: 500;">
                {{ documento(element) }}
              </div>
            </div>
            <div>
              <span style="color: #9ca3af; font-size: 0.72rem;">Tipo ID</span>
              <div style="color: #374151; font-weight: 500;">
                {{ element.tipoUsuarioId === 1 ? 'RUT EMPRESA' : texto(element.tipoId) }}
              </div>
            </div>
            <div *ngIf="element.tipoUsuarioId === 1">
              <span style="color: #9ca3af; font-size: 0.72rem;">Razón social</span>
              <div style="color: #374151; font-weight: 500;">{{ texto(element.razonSocial) }}</div>
            </div>
            <div *ngIf="element.tipoUsuarioId !== 1">
              <span style="color: #9ca3af; font-size: 0.72rem;">País</span>
              <div style="color: #374151; font-weight: 500;">{{ element.paisResidencia || '-' }}</div>
            </div>
            <div>
              <span style="color: #9ca3af; font-size: 0.72rem;">Fecha registro</span>
              <div style="color: #374151; font-weight: 500;">{{ element.created_at | date: 'shortDate' }}</div>
            </div>
          </div>

          <!-- Card actions -->
          <div style="display: flex; justify-content: flex-end; gap: 6px; margin-top: 12px; padding-top: 10px; border-top: 1px solid #f3f4f6;">
            <button *ngIf="!isAdminView" title="Editar"
              [routerLink]="['/wallet/client/edit-payer', element.pagadorId]"
              style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 14px; border: 1px solid #bfdbfe; border-radius: 8px; background: #eff6ff; cursor: pointer; font-size: 0.78rem; font-weight: 600; color: #2563eb;">
              <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #2563eb;">edit</mat-icon>
              Editar
            </button>
            <button *ngIf="puedeEliminar(element)" title="Eliminar"
              (click)="eliminar(element.pagadorId)"
              style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 14px; border: 1px solid #fecaca; border-radius: 8px; background: #fef2f2; cursor: pointer; font-size: 0.78rem; font-weight: 600; color: #dc2626;">
              <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #dc2626;">delete</mat-icon>
              Eliminar
            </button>
            <button *ngIf="isAdminView" title="Ver pagador"
              (click)="openPagadorData(element)"
              style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 14px; border: 1px solid #d1d5db; border-radius: 8px; background: white; cursor: pointer; font-size: 0.78rem; font-weight: 600; color: #1C593D;">
              <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #1C593D;">visibility</mat-icon>
              Ver
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- ── Empty state ── -->
    <ng-template #noPayers>
      <div style="padding: 48px 24px; text-align: center;">
        <mat-icon style="font-size: 48px; width: 48px; height: 48px; color: #d1d5db; margin-bottom: 12px;">person_off</mat-icon>
        <p style="font-size: 0.95rem; font-weight: 600; color: #6b7280; margin: 0 0 4px;">
          No hay pagadores registrados
        </p>
        <p style="font-size: 0.82rem; color: #9ca3af; margin: 0 0 20px;">
          Registra un pagador para comenzar a operar
        </p>
        <button *ngIf="!isAdminView" type="button" routerLink="/wallet/client/payer-invitations"
          style="display: inline-flex; align-items: center; gap: 8px; padding: 10px 28px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.88rem; cursor: pointer; transition: background 0.2s ease;"
          onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">person_add</mat-icon>
          Registrar pagador
        </button>
      </div>
    </ng-template>

  </div>
</div>
